import { REPORT, REPORTS } from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';
import * as queryString from 'query-string';
import { Pagination } from '../store-interfaces';

export type CampaignResourcePayload = {
  success: boolean;
  errors: any[];
};

export enum EAutomationReportingOpts {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  TWICE_PER_MONTH = 'twice per month',
  MONTHLY = 'monthly',
}

export type ReportPayload = ReportType & {
  id: number;
  campaign_id: number;
  created_at: string;
  updated_at: string;
  search_token: string;
};

export type ReportType = {
  active: boolean;
  frequency: EAutomationReportingOpts;
  emails: string[];
};

export default class ReportController extends AuthenticatedController {
  static getReports(
    campaignId: number = -1,
  ): Promise<{ reports: ReportPayload[] } & Pagination> {
    const query = queryString.stringify({
      campaign_id: campaignId,
    });
    return super.get(`${REPORTS}?${query}`);
  }

  static createReport(
    campaignId: number,
    report: ReportType,
  ): Promise<ReportPayload> {
    return super.post(REPORTS, {
      campaignId,
      ...report,
    });
  }

  static updateReport(
    reportId: number,
    report: ReportType,
  ): Promise<{ report: ReportPayload; success: boolean; errors: string[] }> {
    return super.put(REPORT(reportId), report);
  }

  static deleteReport(reportId: number) {
    return super.delete(REPORT(reportId));
  }
}
